import { EscHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { useRemoveIntegrationChannel } from '@modules/integrationsV2/hooks';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import {
  IntegrationChannelViewFragment,
  IntegrationType,
} from 'generated/graphql';
import { IsLoading } from 'v2/core/repository/edge-server/types';

interface RemoveIntegrationChannelConfirmationModalProps {
  integrationID: string;
  integrationChannel: IntegrationChannelViewFragment;
  integrationType: IntegrationType;
  channelID: string;
  channelName: string;
}

export const RemoveIntegrationChannelConfirmationModal = ({
  integrationID,
  integrationChannel,
  integrationType,
  channelID,
  channelName,
}: RemoveIntegrationChannelConfirmationModalProps) => {
  const { closeModal } = useMuiModalContext();

  const { removeIntegrationChannel, status } = useRemoveIntegrationChannel({
    integrationChannel,
    integrationID,
    integrationType,
    channelID,
    channelName,
    onCompleted: () => {
      closeModal();
    },
  });

  return (
    <>
      <ModalHeader
        title={`Remove ${integrationChannel.displayName} Integration?`}
        showCloseButton={false}
      />
      <DialogContent dividers>
        <Typography variant="body2">
          Enterpret will stop ingesting data from integration{' '}
          <strong>{channelName}</strong> once removed. Previously ingested data
          will continue to be available for analysis.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" m={2} spacing={2}>
          <Button
            variant="outlined"
            onClick={() => closeModal()}
            endIcon={<EscHotKeyIcon />}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            autoFocus
            onClick={removeIntegrationChannel}
            loading={IsLoading(status)}
            color="error"
          >
            Remove
          </LoadingButton>
        </Stack>
      </DialogActions>
    </>
  );
};
